import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    AdvancedMarker,
    InfoWindow,
    useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import FlashOnIcon from "@mui/icons-material/FlashOn";
import './flex.css';
import { getProfilePicture } from "services/ConfigServices";
import styles from "assets/jss/material-dashboard-pro-react/cardImagesStyles";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import UserService from "services/UserService";
import { getMBMDashboard, createFlexRequest, confirmFlexRequest } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import uuid from "react-uuid";

const useStyles = makeStyles(styles);

export const AdvancedMarkerFlex = (props) => {
    const options = JSON.parse(localStorage.getItem('memoptions')) || [];
    const simulflex = options.find((x) => x.id === 'flexsimul');
    const classes = useStyles();
    const { key, position, onClick, name, site, title, className, capaclass, infowindowOpen, onInfoWindowClose, bacsrequestlist, bacsid } = props;
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [dashboard, setDashboard] = useState();

    useEffect(() => {
        axios
            .get(getMBMDashboard("" + site.idgroup), {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`,
                },
            })
            .then((res) => {
                setDashboard(res.data);
            });
    }, [site.idgroup]);

    // console.log(dashboard);

    const launchprises = (event) => {
        let assetid = 'Prises';
        launchRequest(assetid);
    };
    const launchcta = (event) => {
        let assetid = 'Ventilation';
        launchRequest(assetid);
    };
    const launchecl = (event) => {
        let assetid = 'Eclairage';
        launchRequest(assetid);
    };
    const launchclim = (event) => {
        let assetid = 'Climatisation';
        launchRequest(assetid);
    };

    const launcheffacement = (event) => {
        let assetid = 'Kergrid';
        launchRequest(assetid);
    };

    const launchRequest = async (assetid) => {
        let requestid =  uuid();
        let begindate =  moment().utc().add(1,'minute');
        let enddate =  moment().utc().add(16,'minute');
        let power = [];
        let powerobj = {
            end: enddate.format('YYYY-MM-DD HH:mm:ss'),
            power: {
                multiplier: "k",
                unit: "W",
                value: 10
            },
            start: begindate.format('YYYY-MM-DD HH:mm:ss'),
        };
        power.push(powerobj);
        axios
            .post(
                createFlexRequest(bacsid,assetid),
                {
                    flexProduct: "XXX",
                    power : power,
                    requestID : requestid
                },
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                        "Content-Type": "application/json; charset=utf-8",
                    },
                }
            )
            .then((res) => {
                if (res.status == 200) {
                    axios
                    .post(
                        confirmFlexRequest(bacsid,assetid,requestid),
                        {
                            flexProduct: "XXX",
                            power : power,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${UserService.getToken()}`,
                                "Content-Type": "application/json; charset=utf-8",
                            },
                        }
                    )
                    .then((res) => {
                        if (res.status == 200) {
                            NotificationManager.success("Requête créée");
                        } else  NotificationManager.error("Une erreur est survenue");
                    })
                    .catch((error) => {
                        NotificationManager.error("Une erreur est survenue");
                        // setLoading(false);
                    });
                } else  NotificationManager.error("Une erreur est survenue");
            })
            .catch((error) => {
                NotificationManager.error("Une erreur est survenue");
                // setLoading(false);
            });
    };

    const getLastRequest = () => {
        let lastrequest = "N/A";
        let lastrequesttime;
        let now = moment();
        if (bacsrequestlist) {
            bacsrequestlist.forEach(request => {
                if (request.power && request.power.length > 0) {
                    request.power.forEach(power => {
                        if (!lastrequesttime || (moment(power.end).isSameOrAfter(lastrequesttime) && moment(power.end).isBefore(now))) {
                            //requete en cours
                            lastrequest = moment(power.end).format("DD/MM/YYYY HH:mm");
                            lastrequesttime = power.end;
                        }
                    });
                }
            });
        }
        return lastrequest;
    }

    const getNextRequest = () => {
        let nextrequest = "N/A";
        let nextrequesttime = moment().add(1, 'year');
        let now = moment();
        if (bacsrequestlist) {
            bacsrequestlist.forEach(request => {
                if (request.power && request.power.length > 0) {
                    request.power.forEach(power => {
                        if (moment(power.start).isSameOrBefore(now) && moment(power.end).isSameOrAfter(now)) {
                            //requete en cours
                            nextrequest = "en cours";
                        }
                        else if (nextrequest !== "en cours" && moment(power.start).isSameOrAfter(now) && moment(power.start).isSameOrBefore(nextrequesttime)) {
                            //requete à venir
                            nextrequest = moment(power.start).format("DD/MM/YYYY HH:mm");
                            nextrequesttime = power.start;
                        }
                    });
                }
            });
        }
        return nextrequest;
    }


    //  console.log(site);
    const renderCustomPin = (capaclass) => {
        return (
            <>
                <div className="custom-pin">
                    <div className="image-container">
                        <span className="icon">
                            <FlashOnIcon

                            />
                        </span>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <AdvancedMarker
                ref={markerRef}
                onClick={(event) => onClick()}
                key={key}
                position={position}
                // onClick={(event) => onMarkerClick(bacs)}
                name={name}
                site={site}
                title={title}
                className={className}
            >
                {renderCustomPin(capaclass)}
            </AdvancedMarker>
            {infowindowOpen && (
                <InfoWindow
                    className={"bacsinfowindow"}
                    anchor={marker}
                    maxWidth={200}
                    onCloseClick={() => onInfoWindowClose()}
                    headerContent={<div class="bacsinfowindowtitle">{site.name}</div>}
                >
                    <div class="bacsinfowindowimgcontainer">
                        <img
                            className={"bacsinfowindowimg"}
                            data-src="holder.js/100px180/"
                            src={site?.imagecode ? getProfilePicture(site.imagecode) : "https://maps.googleapis.com/maps/api/streetview?size=320x180&location=" + site.location.lat + "," + site.location.lng + "&key=" + process.env.REACT_APP_GOOGLE_API_KEY}
                            data-holder-rendered="true"
                            alt={"marker-img"}
                        />
                    </div>
                    <div class='bacsinfotext'>{"Puissance disponible : " + site.parameters?.totalcapacity + " kW"}</div>
                    <div class='bacsinfotext'>{"Dernière activation : " + getLastRequest()}</div>
                    <div class='bacsinfotext'>{"Prochaine activation : " + getNextRequest()}</div>
                    <div class='bacsinfotext'>{"Etat du système : " + (dashboard ? (Math.round((dashboard.equipmentsactives / (dashboard.equipmentsactives + dashboard.equipmentsinactives)) * 100)) + '%' : '')}</div>
                    <div class='bacsinfotext'>{"Assets : "}</div>
                    {
                        site.assets ?
                            site.assets.map((asset) =>
                                <div class='bacsinfotextasset'>{asset.assetID + " : " + asset.parameters?.potentiel?.power?.value + asset.parameters?.potentiel?.power?.multiplier + asset.parameters?.potentiel?.power?.unit}</div>
                            )
                            :
                            <></>
                    }
                    {
                        simulflex ?
                            <>
                                {/* <div class='bacsaction' onClick={() => launchprises()}>Activer les prises</div>
                                <div class='bacsaction' onClick={() => launchcta()}>Activer la CTA</div>
                                <div class='bacsaction' onClick={() => launchecl()}>Activer l'éclairage</div>
                                <div class='bacsaction' onClick={() => launchclim()}>Activer la climatisation</div> */}
                                <div class='bacsaction' onClick={() => launcheffacement()}>Activer Scénario effacement</div>
                                {/* <div class='bacsaction' onClick={() => launchsurconso()}>Activer Scénario consommation</div> */}
                            </>
                            : <></>
                    }
                </InfoWindow>
            )}
        </>
    );
};